import { getDogfoodClient } from '@gonfalon/dogfood-client/getDogfoodClient';

export function recordReactCompilerEvaluation(): void {
  let client: ReturnType<typeof getDogfoodClient>;
  try {
    client = getDogfoodClient();
  } catch {
    return;
  }

  void client
    .waitForInitialization()
    .then((result) => {
      if (typeof result === 'object' && result !== null && 'status' in result && result.status !== 'complete') {
        return;
      }
      void client.variation('enable-react-compiler', false);
    })
    .catch(() => undefined);
}
